import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material"
import { format, parseISO } from "date-fns"
import type { Task } from "@crm-src/types/task"

interface EditScopeDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  taskToEdit: Task | null
  onScopeSelect: (scope: "this" | "all") => void
}

export function EditScopeDialog({
  open,
  onOpenChange,
  taskToEdit,
  onScopeSelect,
}: EditScopeDialogProps) {
  return (
    <Dialog open={open} onClose={() => onOpenChange(false)} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Recurring Task</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This is a recurring task occurrence. How would you like to apply your changes?
        </DialogContentText>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, py: 2 }}>
          <Button
            variant="outlined"
            color="inherit"
            onClick={() => onScopeSelect("this")}
            sx={{
              justifyContent: "flex-start",
              textAlign: "left",
              height: "auto",
              py: 2,
              px: 2,
              whiteSpace: "normal",
            }}
          >
            <Box>
              <Typography sx={{ fontWeight: 600 }}>Only this occurrence</Typography>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                Changes will only apply to {taskToEdit?.original_date && format(parseISO(taskToEdit.original_date), "MMM d, yyyy")}
              </Typography>
            </Box>
          </Button>
          <Button
            variant="outlined"
            color="inherit"
            onClick={() => onScopeSelect("all")}
            sx={{
              justifyContent: "flex-start",
              textAlign: "left",
              height: "auto",
              py: 2,
              px: 2,
              whiteSpace: "normal",
            }}
          >
            <Box>
              <Typography sx={{ fontWeight: 600 }}>All occurrences</Typography>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                Changes will apply to all past, present, and future occurrences
              </Typography>
            </Box>
          </Button>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="inherit" onClick={() => onOpenChange(false)}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}
